import Box from "@mui/material/Box";
import React from "react";
import Grid from "@mui/material/Unstable_Grid2";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import PatientDatas from "src/modules/medcard/patient-datas";
import { useTranslate } from "src/locales";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import { ByzMuiDateTimePicker } from "src/components/core-components/mui/inputs/ByzMuiDateTimePicker";
interface EditPageProps {
  rowData: any;
  onClose: () => void;
}
//IDOGAN;449733;25042025
const EditPage: React.FC<EditPageProps> = ({ rowData, onClose }) => {
  const { t } = useTranslate();
  return (
    <>
      <PatientDatas isCreateMedCard={true} isOpenMedCard={true} />
      <Box sx={{ padding: "20px", width: "100%" }}>
        <Grid container spacing={2}>
          <Grid md={9} xs={6} container direction={"column"} spacing={3}>
            <Grid
              md={6}
              sx={{
                backgroundColor: "#F4F7FE",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <ByzMuiTypography isTitle>
                {t("patient-diet-procedures.edit-page.change")}
              </ByzMuiTypography>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{
                  borderBottom: "1px solid #E0E0E0",
                  paddingRight: "10px",
                  display: "flex",
                }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("patient-diet-procedures.edit-page.date")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiDateTimePicker
                  sx={{ width: "100%", maxWidth: "300px" }}
                />
              </Grid>
            </Grid>
            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("note")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6}>
                <ByzMuiTextField
                  sx={{ width: "300px" }}
                  color="info"
                  label="Not"
                  variant="outlined"
                />
              </Grid>
            </Grid>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("patient-diet-procedures.edit-page.companion")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField
                      {...params}
                      label="Hareket"
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label={t("open-process-menu.select")}
                  placeholder={t("open-process-menu.select")}
                />
              </Grid>
            </Grid>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("patient-diet-procedures.edit-page.add-snack")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiCheckBox sx={{ marginLeft: "5px" }} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
export default EditPage;
